
import {
  getBFSReport,
  getLoginSummary
} from '@/components/insurances/insurance.service'
import { PaginationVM, Role, SelectVM } from '@/models'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getCurrentUser, getUserRole } from '../admin/users/users.service'
import moment from 'moment'
import xlsx from 'json-as-xlsx'
import Multiselect from 'vue-multiselect'
import { getResolve } from '../doctors/doctors.service'

type Tri = 'any' | 'true' | 'false'

@Component({
  components: {
    Multiselect
  }
})
export default class LoginSummary extends Vue {
  public roles: SelectVM[] = []

  public statusList = [
    {
      label: 'Active',
      value: true
    },
    {
      label: 'Inactive',
      value: false
    }
  ]
  public twoFactorList = [
    {
      label: 'Set',
      value: true
    },
    {
      label: 'Not Set',
      value: false
    }
  ]

  public selectedStatusFilter = null
  public selectedTwoFactorFilter = null

  public selectedGender: string | null = null
  public selectedRole: string | null = null
  public selectedRoleFilter: string | null = null

  public fields = [
    { key: 'index', label: 'Index', sortable: true, order: 1 },
    { key: 'userName', label: 'User', sortable: true, order: 2 },
    { key: 'fullName', label: 'Full Name', sortable: true, order: 3 },
    { key: 'email', label: 'Email', sortable: true, order: 3 },

    { key: 'rolName', label: 'Role', sortable: true, order: 4 },
    {
      key: 'loginStatus',
      label: 'User Status',
      sortable: true,
      order: 5,
      formatter: 'formatActive'
    },
    {
      key: 'firstLogin',
      label: 'First Login',
      sortable: true,
      order: 6,
      formatter: 'formatDateTime'
    },
    {
      key: 'lastLogin',
      label: 'Last Login',
      sortable: true,
      order: 7,
      formatter: 'formatDateTime'
    },
    {
      key: 'policyAcceptanceDate',
      label: 'Policy Acceptance Date',
      sortable: true,
      order: 7,
      formatter: 'formatDate'
    },
    // { key: 'daysafter', label: 'Days After', sortable: true, order: 8 },
    { key: 'mtdLogin', label: 'MTD Login', sortable: true, order: 9 },
    { key: 'qtdLogin', label: 'QTD Login', sortable: true, order: 10 },
    { key: 'ytdLogin', label: 'YTD Login', sortable: true, order: 11 },
    { key: 'alL_Login', label: 'All Login', sortable: true, order: 12 },
    {
      key: 'current2FA',
      label: 'Current 2FA',
      sortable: true,
      order: 13,
      formatter: 'formatBool'
    },
    {
      key: 'successLoginRate',
      label: 'Success Login Rate MTD',
      sortable: true,
      order: 14,
      formatter: 'formatPercentage'
    }
  ]
  public currentUser = ''
  public items = []
  public perPage = 10
  public pageOptions = [10, 20, 50, 100, 250, 500, 1000]
  public pagination = {} as PaginationVM
  public searchQuery = ''
  public showSearch = false
  private async created() {
    await this._getLoginSummary()
  }
  // public async mounted() {

  // }
  @Watch('perPage')
  perPageChange() {
    this._getLoginSummary()
  }
  get _pagination() {
    return this.pagination
  }
  public async resetFilters() {
    this.searchQuery = ''
    this.selectedRoleFilter = null
    this.selectedStatusFilter = null
    this.selectedTwoFactorFilter = null
    await this._getLoginSummary(1)
  }
  public async onPageChange(pageNumber: number) {
    await this._getLoginSummary(pageNumber, this.searchQuery)
  }
  public async filter() {
    await this._getLoginSummary(1, this.searchQuery)
  }
  public async cleanFilter() {
    this.searchQuery = ''
    await this._getLoginSummary(1, this.searchQuery)
  }
  public async _getLoginSummary(pageNumber = 1, searchQuery = '') {
    // this.currentUser = getCurrentUser()

    const response = await getResolve()
    if (getUserRole() == Role.InsuranceStaff) {
      response.roles = response.roles.filter(c => c.label == 'Doctor')
    }

    this.roles = response.roles

    const IPANumber =
      getUserRole() == Role.InsuranceStaff
        ? JSON.parse(localStorage.getItem('currentUser')).ipaNumber
        : ''

    const doctorId =
      getUserRole() == Role.Doctor
        ? JSON.parse(localStorage.getItem('currentUser')).rmtUserId
        : ''

    const res = await getLoginSummary(
      {
        pageNumber,
        pageSize: this.perPage,
        searchQuery: this.searchQuery,
        roleName: this.selectedRoleFilter?.label,
        active: this.selectedStatusFilter?.value, //this.tri(this.selectedStatusFilter?.value || true),
        twoFA: this.selectedTwoFactorFilter?.value //this.tri(this.selectedTwoFactorFilter?.value || true)
      },
      IPANumber,
      doctorId
    )

    this.items = res.data
    this.pagination = JSON.parse(res.headers['x-pagination'])
  }
  public formatStatus(value: boolean) {
    if (value) {
      return 'Success'
    } else if (value == false) {
      return 'Fail'
    }
  }
  public formatBool(value: boolean) {
    if (value) {
      return 'Yes'
    } else if (value == false) {
      return 'No'
    }
  }
  public formatActive(value: boolean) {
    if (value) {
      return 'Active'
    } else if (value == false) {
      return 'Inactive'
    }
  }
  public formatPercentage(value: string) {
    const percentage = value ? +(+value * 100).toFixed(2) + '%' : 0 + '%'
    return percentage
  }
  public async exportTable() {
    let items = []
    const IPANumber =
      getUserRole() == Role.InsuranceStaff
        ? JSON.parse(localStorage.getItem('currentUser')).ipaNumber
        : ''
    const doctorId =
      getUserRole() == Role.Doctor
        ? JSON.parse(localStorage.getItem('currentUser')).rmtUserId
        : ''
    // console.log(IPANumber)
    const params = {
      pageNumber: 1,
      pageSize: 999999,
      SearchQuery: this.searchQuery
    }
    const response = await getLoginSummary(params, IPANumber, doctorId)
    items = response.data

    // console.log(response)
    const updatedArray = items.map(obj => {
      const newObj = {}
      // Sort the first array based on the order property
      this.fields.sort((a, b) => a.order - b.order)
      // Get the keys in the order specified by the first array
      const keys = this.fields.map(x => x.key).filter(c => c != 'index')
      // Sort the keys of the object
      keys.forEach(key => {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          const label = this.fields.find(x => x.key === key).label
          newObj[label.toLowerCase()] = obj[key.toLowerCase()]
        }
      })
      return newObj
    })
    // console.log(updatedArray)
    const data = [
      {
        sheet: 'Login Summary',
        columns: [],
        content: []
      }
    ]

    data[0].columns = this.fields
      .map(c => {
        return {
          label: c.label,
          value: c.key
        }
      })
      .filter(c => c.value != 'index')
    // if (getUserRole() === Role.Doctor) {
    //   // alert(1)
    //   data[0].columns = [
    //     { label: 'NPI', value: 'documentID' },
    //     { label: 'Doctor Name', value: 'doctor' }
    //   ].concat(data[0].columns)
    // }
    data[0].content = items.map(c => {
      return {
        ...c,
        loginStatus: this.formatActive(c.loginStatus),
        current2FA: this.formatBool(c.current2FA),
        firstLogin: this.formatDateTime(c.firstLogin),
        lastLogin: this.formatDateTime(c.lastLogin),
        successLoginRate: this.formatPercentage(c.successLoginRate)
      }
    })

    const settings = {
      fileName: 'Login Summary Report', // Name of the resulting spreadsheet
      extraLength: 3, // A bigger number means that columns will be wider
      writeMode: 'writeFile', // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
      writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
      RTL: false // Display the columns from right-to-left (the default value is false)
    }
    xlsx(data, settings) // Will download the excel file
  }
  public formatMoney(value) {
    return new Intl.NumberFormat('us-US', {
      style: 'currency',
      currency: 'USD'
    }).format(value)
  }

  public formatDateTime(value: string) {
    if (value) return moment(value).format('MM/DD/YYYY HH:mm')

    // → "09/08/2025 18:23:01"
  }
  public formatDate(value: string) {
    if (value) return moment(value).format('MM/DD/YYYY')
  }
}
